import { inject, Injectable } from '@angular/core';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { FormGroup } from '@angular/forms';
import { CalculationResultStatus, CallidusSkipperVersicherungspraemieCalcDto, VersicherungspraemieCalculationResultDto } from '@backend/models';
import { SkipperStateService } from '@shared/services/skipper-state.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SkipperCalculationService {
  private readonly skipperStateService = inject(SkipperStateService);

  calculate(form: FormGroup<SkipperFormModel>): Observable<VersicherungspraemieCalculationResultDto> {
    const skipperHaftpflichtControls = form.controls.skipperHaftpflicht.controls;
    const skipperRechtsschutzControls = form.controls.skipperRechtsschutz.controls;

    const cmd: CallidusSkipperVersicherungspraemieCalcDto = {
      // Haftpflicht
      callidusSkipperVersicherungssummeKunde: skipperHaftpflichtControls.callidusSkipperVersicherungssummeKunde.value,
      hasSchaedenBereitsErlitten: skipperHaftpflichtControls.hasSchaedenBereitsErlitten.value,
      hasRisikenBereitsVersichert: skipperHaftpflichtControls.hasRisikenBereitsVersichert.value,
      hasBeantragteRisikenGekuendigtOderAbgelehnt: skipperHaftpflichtControls.hasBeantragteRisikenGekuendigtOderAbgelehnt.value,

      // Rechtsschutz
      isSelbstbehaltSelected: skipperRechtsschutzControls.isSelbstbehaltSelected.value,
      isKundeAdditionalCharterVertragsRechtsschutzSelected: skipperRechtsschutzControls.isKundeAdditionalCharterVertragsRechtsschutzSelected.value
    } as CallidusSkipperVersicherungspraemieCalcDto;

    return this.skipperStateService.calculateSkipperPraemie(cmd);
  }

  getCalculationResult(): VersicherungspraemieCalculationResultDto | null {
    return this.skipperStateService.getSkipperCalculationResult();
  }

  showErrorMessages(): boolean {
    const calculationResult = this.getCalculationResult();
    return calculationResult !== null &&
      (calculationResult.publicCalculationResultStatus === CalculationResultStatus.OkWithWarning ||
        calculationResult.publicCalculationResultStatus === CalculationResultStatus.Error);
  }
}
